export enum ErrorActionType {
  ErrorRaised         = 'ERROR_RAISED',
  ErrorRaisedRemoved  = 'ERROR_RAISED_REMOVED',
  ErrorHandled        = 'ERROR_HANDLED',
  UnhandledError      = 'UNHANDLED_ERROR',
}
